<template>
    <x-text-field
        :name="name"
        v-model="num"
        :rules="fieldRules"
        :mask="mask"
        :persistent-hint=true
        :hide-details="hideDetails"
        :maxlength="maxLength"
        :disabled="disabled"
        :readonly="readonly"
        ref="currencyTextField"
        v-bind="$attrs"
        :label="label"
    >
    </x-text-field>
</template>

<script>
    import rules from "~/mixins/rules";

    export default {
        inheritAttrs: false,
        name: 'XCurrencyTextField',
        mixins: [rules],
        props: {
            value: {},
            name: {},
            rules: {},
            currency: {},
            inputStyle: {},
            items: {},
            hideDetails: {
                type: Boolean
            },
            hideHelper: Boolean,
            disabled: {},
            readonly: {
                type: Boolean
            },
            mask: {},
            maxLength: {
                default: 18,
                type: Number
            },
            label: String
        },
        computed: {
            num: {
                get () {
                    return this.$options.filters.formatMoney(this.value, 2);
                },
                set (newValue) {
                    const cleanNumber = ( newValue === null || newValue === undefined || newValue.trim() === "" ) ? '' : parseFloat(newValue.toString().replace(/,/g, ''));
                    this.$emit('input', cleanNumber);
                }
            },
            fieldRules() {
                if (this.rules === undefined) {
                    return [];
                }

                return this.rules.concat([
                    v => this.ruleNumericString(v, this.label || 'Field')
                ]);
            }
        },
        watch: {
            num(newNum = '', oldNum = '') {
                if (!newNum) {
                    newNum = '';
                }

                if (!oldNum) {
                    oldNum = '';
                }
                // Keep the cursor in the correct position after formatting the number (1000 to 1,000 etc)
                const input = this.$refs.currencyTextField.$refs.input;
                const movement = (newNum.match(/,/g) || []).length - (oldNum.match(/,/g) || []).length;
                const newPos = input.selectionStart + movement;

                this.$nextTick(() => {
                    input.selectionStart = newPos;
                    input.selectionEnd = newPos;
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
div.v-input.theme--dark.v-text-field.v-text-field--prefix {
    ::v-deep .v-input__control .v-input__slot {
        padding-left: 0;
        font-size: rem(16px);

        .v-text-field__prefix {
            padding: 0 10px;
            background: #EFF1F4;
            color: #4B4D52;
            min-height: 100%;
            vertical-align: middle;
            display: flex;
            align-items: center;
            border-radius: 2px 0 0 2px;
            font-size: rem(13px);
            font-weight: 700;
        }

        input {
            padding-left: 10px;
        }
    }
}
</style>
